/** @module api/ems_chai_scripts */

import { apiCall } from '@/api/index'
import {
  apiV1EnergyManagementSystemEmsChaiScriptPath,
  apiV1EnergyManagementSystemEmsChaiScriptsPath
} from '@/../lib/routes'

export function getChaiScripts({ ctxt = 'customer', emsId } = {}) {
  const payload = {}

  return apiCall({
    path: apiV1EnergyManagementSystemEmsChaiScriptsPath(ctxt, emsId),
    payload
  })
}

export function getChaiScript({ ctxt = 'customer', emsId, scriptId } = {}) {
  const payload = {}

  return apiCall({
    path: apiV1EnergyManagementSystemEmsChaiScriptPath(ctxt, emsId, scriptId),
    payload
  })
}

export function updateChaiScript({ ctxt = 'customer', emsId, scriptId, data } = {}) {
  const payload = {
    data: {
      type: 'ems_chai_scripts',
      id: scriptId,
      attributes: {
        prmts: data
      }
    }
  }

  return apiCall({
    method: 'PATCH',
    path: apiV1EnergyManagementSystemEmsChaiScriptPath(ctxt, emsId, scriptId),
    payload
  })
}
